import React from 'react';
import d3 from 'd3';

/*function mapPrint(val) {
    console.log(val);
    return val;
}*/




export default class PieChartPie extends React.Component {
    constructor(props) {
        super(props);
        
        //this.state = {selectedIdx: null, hoveredIdx: null}
    }

    render() {
        function isLeftAngle(angle) {
            if(angle>(Math.PI/2) && angle<(3*Math.PI/2)) {
                return true;
            }
            return false;
        }
        const outerRadius = Math.min(
            Math.floor((this.props.width-this.props.paddingLeft-this.props.paddingRight)/2),
            Math.floor((this.props.height-this.props.paddingTop-this.props.paddingBottom)/2)
        );
        const innerRadius = outerRadius-20;
        const total = this.props.data.map(v => v.value).reduce((prev,cur) => prev + cur, 0);
        const angles = this.props.data
        .map(v => v.value)
        .reduce((prev,cur,idx,arr) => {
            let curfraction = cur/total;
            let startAngle = idx==0?0:prev[prev.length-1][1];
            let endAngle = startAngle + curfraction * 2 * Math.PI;
            prev.push([startAngle,endAngle])
            return prev;
        },[]);
        
        const arcs = angles
        .map(v => d3.svg.arc().innerRadius(innerRadius).outerRadius(outerRadius).startAngle(v[0]).endAngle(v[1]));
        
        const midangles = angles.reduce((prev,cur,idx,arr) => {
            let startAngle = 0;
            if(idx>0) {
                startAngle = arr[idx-1][1];
            }
            prev.push((cur[0]+cur[1])/2);
            return prev;
        },[]);
        
        let spread = 10;
        let spreadpow = 29;
        let firstlines = midangles.map(v => 
            [[(outerRadius+5)*Math.cos(v-Math.PI/2), (outerRadius+5)*Math.sin(v-Math.PI/2)],
            [(outerRadius+15)*Math.cos(v-Math.PI/2), (outerRadius+15)*Math.sin(v-Math.PI/2)  + spread*Math.pow(Math.sin(v-Math.PI/2),spreadpow)]]);
        let secondlines = midangles.map(v => 
            [[(outerRadius+15)*Math.cos(v-Math.PI/2), (outerRadius+15)*Math.sin(v-Math.PI/2)  + spread*Math.pow(Math.sin(v-Math.PI/2),spreadpow)],
            [isLeftAngle(v-Math.PI/2)?-1*outerRadius-20:outerRadius+20, (outerRadius+15)*Math.sin(v-Math.PI/2)  + spread*Math.pow(Math.sin(v-Math.PI/2),spreadpow)]]);
        
        let textys = firstlines.map(v => v[1][1]);
        let textxs = midangles.map(v => isLeftAngle(v-Math.PI/2)?-1*outerRadius-25:outerRadius+25);
        let textanchors = midangles.map(v => isLeftAngle(v-Math.PI/2)?'end':'start');
        
       
        
        /*let makeMouseEnterFunc = (func,i) => {
            return () => {
                console.log("ENTERED");
                this.setState({hoveredIdx:i});
                return func?func(...arguments):undefined;
            }
        };   
        let makeMouseLeaveFunc = (func,i) => {
            return () => {
                console.log("EXITED");
                this.setState({hoveredIdx:null});
                return func?func(...arguments):undefined;
            }
        };
        let makeClickFunc = (func,i) => {
            return () => {
                console.log("CLICK");
                if(this.state.selectedIdx == i) {
                    this.setState({selectedIdx:null});    
                } else {
                    this.setState({selectedIdx:i});
                }
                return func?func(...arguments):undefined;
            }
        };*/
        let wrapHandler = (func,i) => {
            return () => {
                return func?func(i,...arguments):undefined;
            }
        };
        
        return <g 
            className={"piechartpie "+(this.props.selected!=null?" selecting":"")+(this.props.hovered!=null?" hovering":"")} 
            transform={"translate("+(outerRadius+this.props.paddingLeft)+","+(outerRadius+this.props.paddingTop)+")"}>
            <g className="pieslices">{
                arcs.map((pathfunc,i) => <path 
                    key={"slice_"+i}
                    d={pathfunc()}
                    fill={this.props.data[i].color}
                    onMouseOver={wrapHandler(this.props.onSliceMouseOver,i)}
                    onMouseEnter={wrapHandler(this.props.onSliceMouseEnter,i)}
                    onMouseLeave={wrapHandler(this.props.onSliceMouseLeave,i)}
                    onClick={wrapHandler(this.props.onSliceClick,i)}
                    className={(this.props.selected==i?"selected ":"") + (this.props.hovered==i?"hovered":"")}/>
                    )
            }</g>
            <g className="pieinnercontent">
                <foreignObject
                    x={innerRadius*Math.cos(3*Math.PI/4)}
                    y={-1*innerRadius*Math.sin(3*Math.PI/4)}
                    width={innerRadius * (Math.cos(Math.PI/4)-Math.cos(3*Math.PI/4))}
                    height={innerRadius * (Math.sin(Math.PI/4)-Math.sin(-1*Math.PI/4))}
                >
                    {this.props.innerContent}
                 </foreignObject>
            </g>
            <g className="pielines">{
                firstlines.map((lineseg,i) => <line 
                    key={"line1"+i} 
                    x1={lineseg[0][0]} 
                    y1={lineseg[0][1]} 
                    x2={lineseg[1][0]} 
                    y2={lineseg[1][1]}
                    stroke="#000000"/>)
            }
            {
                secondlines.map((lineseg,i) => <line 
                    key={"line2"+i} 
                    x1={lineseg[0][0]} 
                    y1={lineseg[0][1]} 
                    x2={lineseg[1][0]} 
                    y2={lineseg[1][1]}
                    stroke="#000000"/>)
            }</g>
            <g className="pielabels">{
                this.props.data.map((v,i) => <text 
                    key={"text_"+i} 
                    style={{textAnchor:textanchors[i], dominantBaseline:"middle"}}
                    x={textxs[i]}
                    y={textys[i]}>
                        {(v.value/total*100).toFixed(0)+"%"}
                    </text>)
            }</g>
        </g>
    }
}


// WEBPACK FOOTER //
// ./src/js/components/charting/PieChartPie/PieChartPie.jsx